var map = {
	"./01.svg": "Xwtu",
	"./02.svg": "6BK+",
	"./03.svg": "1Kqm",
	"./04.svg": "Q8YG",
	"./05.svg": "p7iA",
	"./06.svg": "mVXn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s4QZ";